// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__1AAv8","story-card":"organism1-m__story-card__1N2gK"};